import React, { useState } from "react";
import LeftNav from "../components/common/LeftNav"
import TopNav from "../components/common/TopNav"
import "../assets/styles/PersonalIDs.css";
import personalleft from "../assets/img/personal-left.svg";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa"; // 👈 for eye toggle icons
import authService from "../../services/authService";

export default function ForgotPassword() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: "",
    otp: "",
    newPassword: "",
    confirmPassword: "",
  });

  const [showPassword, setShowPassword] = useState({
    new: false,
    confirm: false,
  });

  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState(1); // 1: email, 2: otp + password
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSendOTP = async () => {
    if (!formData.email) {
      setError("Please enter your email address");
      return;
    }

    setLoading(true);
    setError("");
    setMessage("");

    try {
      const response = await authService.sendPasswordResetOTP({ email: formData.email });

      if (response.success) {
        setStep(2);
        setMessage("OTP has been sent to your email address");
      } else {
        setError(response.message || "Failed to send OTP");
      }
    } catch (err) {
      setError("An error occurred while sending OTP");
    } finally {
      setLoading(false);
    }
  };

  const handleResetPassword = async () => {
    // Validation
    if (!formData.email || !formData.otp || !formData.newPassword || !formData.confirmPassword) {
      setError("Please fill in all fields");
      return;
    }

    if (formData.newPassword !== formData.confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    if (formData.newPassword.length < 6) {
      setError("Password must be at least 6 characters long");
      return;
    }

    setLoading(true);
    setError("");
    setMessage("");

    try {
      // First verify the OTP
      const verifyResponse = await authService.verifyPasswordResetOTP({
        email: formData.email,
        otp: formData.otp
      });

      if (!verifyResponse.success) {
        setError(verifyResponse.message || "Invalid OTP");
        setLoading(false);
        return;
      }

      // If OTP is valid, reset the password
      const resetResponse = await authService.resetPasswordWithOTP({
        email: formData.email,
        otp: formData.otp,
        newPassword: formData.newPassword
      });

      if (resetResponse.success) {
        setMessage("Password has been reset successfully!");
        setTimeout(() => {
          navigate(-1);
        }, 2000);
      } else {
        setError(resetResponse.message || "Failed to reset password");
      }
    } catch (err) {
      setError("An error occurred while resetting password");
    } finally {
      setLoading(false);
    }
  };

  const handleSave = () => {
    if (step === 1) {
      handleSendOTP();
    } else {
      handleResetPassword();
    }
  };

  return (
    <div className="d-flex" style={{ background: "#fafbfc", minHeight: "100vh" }}>
         <LeftNav />
         <div className="main-content flex-grow-1">
           <TopNav />
        <div className="p-4">
          <div className="">
            <div className="card p-4 personal-ids-card">
              {/* Header */}
              <div className="d-flex justify-content-between align-items-center mb-4">
                <h6 className="personal-head mb-0">
                  <img
                    src={personalleft}
                    style={{ cursor: "pointer" }}
                    className="me-2"
                    width={28}
                    height={28}
                    onClick={() => navigate(-1)}
                  />
                  Forgot Password
                </h6>
              </div>

              {/* Success/Error Messages */}
              {message && (
                <div className="alert alert-success mb-3">
                  {message}
                </div>
              )}
              {error && (
                <div className="alert alert-danger mb-3">
                  {error}
                </div>
              )}

              {/* Email */}
              <div className="form-group mb-3">
                <label className="form-label personal-label">Enter your registered email</label>
                <input
                  type="email"
                  name="email"
                  className="form-control personal-input"
                  value={formData.email}
                  onChange={handleChange}
                  disabled={step === 2}
                />
              </div>

              {/* OTP - Only show in step 2 */}
              {step === 2 && (
                <div className="form-group mb-3">
                  <label className="form-label personal-label">Enter OTP sent to your email</label>
                  <input
                    type="text"
                    name="otp"
                    className="form-control personal-input"
                    value={formData.otp}
                    onChange={handleChange}
                    placeholder="Enter 6-digit OTP"
                  />
                </div>
              )}

              {/* New Password - Only show in step 2 */}
              {step === 2 && (
                <div className="form-group mb-3" style={{ position: "relative" }}>
                  <label className="form-label personal-label">Enter new password</label>
                  <input
                    type={showPassword.new ? "text" : "password"}
                    name="newPassword"
                    className="form-control personal-input"
                    value={formData.newPassword}
                    onChange={handleChange}
                    placeholder="Enter new password"
                  />
                  <span
                    onClick={() =>
                      setShowPassword((prev) => ({ ...prev, new: !prev.new }))
                    }
                    style={{
                      position: "absolute",
                      right: "12px",
                      top: "38px",
                      cursor: "pointer",
                      color: "#6B7280",
                    }}
                  >
                    {showPassword.new ? <FaEyeSlash /> : <FaEye />}
                  </span>
                </div>
              )}

              {/* Confirm Password - Only show in step 2 */}
              {step === 2 && (
                <div className="form-group mb-3" style={{ position: "relative" }}>
                  <label className="form-label personal-label">Confirm new password</label>
                  <input
                    type={showPassword.confirm ? "text" : "password"}
                    name="confirmPassword"
                    className="form-control personal-input"
                    value={formData.confirmPassword}
                    onChange={handleChange}
                    placeholder="Confirm new password"
                  />
                  <span
                    onClick={() =>
                      setShowPassword((prev) => ({
                        ...prev,
                        confirm: !prev.confirm,
                      }))
                    }
                    style={{
                      position: "absolute",
                      right: "12px",
                      top: "38px",
                      cursor: "pointer",
                      color: "#6B7280",
                    }}
                  >
                    {showPassword.confirm ? <FaEyeSlash /> : <FaEye />}
                  </span>
                </div>
              )}

              {/* Save Button */}
              <div className="d-flex justify-content-end">
                <button
                  className="personal-uspbtn d-flex justify-content-center align-items-center px-4"
                  onClick={handleSave}
                  disabled={loading}
                  style={{ minWidth: "120px" }}
                >
                  {loading ? (
                    <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                  ) : null}
                  <span className="personal-uspbtntext">
                    {loading ? "Processing..." : step === 1 ? "Send OTP" : "Reset Password"}
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}